import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';

import { toast } from 'react-toastify';
import API from '../../Utils/api';
import '../AuthShared.css';

export default function ForgotPasswordPage() {
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting }
    } = useForm({ mode: 'onBlur' });

    const onSubmit = async ({ email }) => {
        try {
            await API.forgotPassword({ email });
            toast.success('Recovery email was sent!', {
                position: 'bottom-center'
            });
        } catch {
            toast.error(`Couldn't send a password recovery email!`, {
                position: 'bottom-center'
            });
        }
    };

    return (
        <div className='auth'>
            <div className='auth-card'>
                <div className='auth-head'>
                    <h1>Reset your password</h1>
                    <p>
                        Enter the email address on your account and we will send you a
                        link to set a new password.
                    </p>
                </div>

                {/* The submit button used to sit outside this form, so clicking it
                    ran handleSubmit with no form to read and nothing was sent. */}
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <div className='auth-field'>
                        <label htmlFor='forgot-email'>Email address</label>
                        <input
                            id='forgot-email'
                            type='email'
                            autoComplete='email'
                            aria-invalid={errors.email ? 'true' : undefined}
                            {...register('email', {
                                required: 'Enter your email address.',
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: 'That email address does not look right.'
                                }
                            })}
                        />
                        {errors.email && (
                            <p className='auth-error' role='alert'>
                                {errors.email.message}
                            </p>
                        )}
                    </div>

                    <button type='submit' className='auth-submit' disabled={isSubmitting}>
                        {isSubmitting ? 'Sending' : 'Send recovery email'}
                    </button>
                </form>

                <p className='auth-swap'>
                    Remembered it?{' '}
                    <button
                        type='button'
                        className='auth-link'
                        onClick={() => navigate('/login')}
                    >
                        Back to log in
                    </button>
                </p>
            </div>
        </div>
    );
}
